import Image from "next/image";
import Link from "next/link";

import BlogAuthor from "../Blogs/Blog-Sections/Blog-Author";
// import ComntForm from "./Blog-Sections/ComntForm";
// import Comment from "./Blog-Sections/Comment";
import { MDXRemote } from 'next-mdx-remote'
// import DisqusComments from "../Blogs/Blog-Sections/DisqusComments";
// import TikTokShort from "../Videos/TikTokShort"
import YouTubeShort from "../Media/YouTubeShort"
import ImageSourceCaption from "../Media/ImageSourceCaption";
import GoogleAdLarge from "../Ads/GoogleAdLarge";
import DisqusComments from "../Common/DisqusComments";

const ShortsEpisode = ({ blogType, matchedBlog, blogContent, author }) => {
  // console.log(blogType);
  return (
    <>
      <div className="content">

        <div className="post-thumbnail mb--30 position-relative wp-block-image alignwide">
          <figure>
            {matchedBlog.image.poster && (
              <Image
                src={matchedBlog.image.poster}
                width={1085}
                height={645}
                priority
                alt="Blog Images"
              />
            )}
            <ImageSourceCaption sourceText={matchedBlog.image.source} />
          </figure>
        </div>
        {/* <p>{matchedBlog.descOne}</p> */}

        <MDXRemote {...blogContent} />

        {/* <blockquote className="wp-block-quote">
          <p>{matchedBlog.quote}</p>
          <cite>
            <Link href="https://themeforest.net/user/rainbow-themes/portfolio">
              {matchedBlog.city}
            </Link>
          </cite>
        </blockquote> */}

        {/* <div className="wp-block-gallery columns-3 is-cropped">
          <ul className="blocks-gallery-grid">
            {matchedBlog &&
              matchedBlog.gallery.map((item, innerIndex) => (
                <li className="blocks-gallery-item" key={innerIndex}>
                  <figure>
                    {item.galleryImg && (
                      <Image
                        className="radius-4"
                        src={item.galleryImg}
                        width={255}
                        height={143}
                        priority
                        alt="Blog Images"
                      />
                    )}
                  </figure>
                </li>
              ))}
          </ul>
        </div> */}

        {/* <div className="tagcloud">
          {matchedBlog &&
            matchedBlog.tag.map((tagItem, innerIndex) => (
              <Link href="#" key={innerIndex}>
                {tagItem.tag}
              </Link>
            ))}
        </div> */}

        {/* {blogType == "short" && (
          // <h3> Short in Tiktok</h3>
          <TikTokShort />
        )} */}

        {blogType == "short" && (
          // <h3> Short in Tiktok</h3>
          <YouTubeShort videoId={matchedBlog.youTubeVideoId} />
        )}

        <div className="social-share-block">
          <div className="post-like">
            <Link href="#">
              <i className="feather feather-thumbs-up"></i>
              <span>2.2k Like</span>
            </Link>
          </div>
          <ul className="social-icon social-default transparent-with-border">
            {matchedBlog &&
              matchedBlog.social.map((socialItem, innerIndex) => (
                <li key={innerIndex}>
                  <Link href={socialItem.url}>
                    <i className={socialItem.icon}></i>
                  </Link>
                </li>
              ))}
          </ul>
        </div>

        <GoogleAdLarge />

        <div className="about-author">
          <BlogAuthor author={author} />
          {/* {matchedBlog &&
            matchedBlog.author.map((author, innerIndex) => (
              <BlogAuthor {...author} author={author} key={innerIndex} />
            ))} */}
        </div>

        <DisqusComments blogType={blogType} blog={matchedBlog} />

        {/* <div className="rbt-comment-area">
          <div className="rbt-total-comment-post">
            <div className="title">
              <h4 className="mb--0">30+ Comments</h4>
            </div>
            <div className="add-comment-button">
              <a
                className="rbt-btn btn-gradient icon-hover radius-round btn-md"
                href="#"
              >
                <span className="btn-text">Add Your Comment</span>
                <span className="btn-icon">
                  <i className="feather-arrow-right"></i>
                </span>
              </a>
            </div>
          </div>
          <ComntForm />
        </div>
        <div className="rbt-comment-area">
          <h4 className="title">2 comments</h4>
          <ul className="comment-list">
            {matchedBlog &&
              matchedBlog.comment.map((comnt, innerIndex) => (
                <Comment {...comnt} comnt={comnt} key={innerIndex} />
              ))}
          </ul>
        </div> */}
      </div >
    </>
  );
};

export default ShortsEpisode;
